
document.addEventListener("DOMContentLoaded", function() {
  function initMainCollectionSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.main-collection-slider').hasClass('slick-initialized')) {
        $('.main-collection-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.main-collection-slider').hasClass('slick-initialized')) {
        $('.main-collection-slider').slick('unslick');
      }
    }
  }

  initMainCollectionSlider();

  window.addEventListener('resize', function() {
    initMainCollectionSlider();
  });
});
document.addEventListener("DOMContentLoaded", function() {
  function initIconWithTextSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.icon-with-text-slider').hasClass('slick-initialized')) {
        $('.icon-with-text-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.icon-with-text-slider').hasClass('slick-initialized')) {
        $('.icon-with-text-slider').slick('unslick');
      }
    }
  }

  initIconWithTextSlider();

  window.addEventListener('resize', function() {
    initIconWithTextSlider();
  });
});
document.addEventListener("DOMContentLoaded", function() {
  function initShippingIconSlider() {
    if (window.innerWidth <= 768) {
      if (!$('.shipping-icon-slider').hasClass('slick-initialized')) {
        $('.shipping-icon-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: true,
          speed: 800,
        });
      }
    } else {
      if ($('.shipping-icon-slider').hasClass('slick-initialized')) {
        $('.shipping-icon-slider').slick('unslick');
      }
    }
  }

  initShippingIconSlider();

  window.addEventListener('resize', function() {
    initShippingIconSlider();
  });
});

